import { gql } from "@apollo/client";

export const GET_ALL_FIGURA_PROFESIONAL = gql`
query GetAllFiguraProfesionalById($idTipoProfesional: Int!) {
    allFiguraProfesionalById(idTipoProfesional: $idTipoProfesional){
            idFiguraProfesional,
            descripcion
      }
}`;